document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('[data-return-form]');
    if (!form) return;

    const reason = form.querySelector('[data-return-reason]');
    const reasonPreview = form.querySelector('[data-return-reason-preview]');
    const emptyReason = form.dataset.emptyReason || '';

    const updateSummary = function () {
        if (!reason || !reasonPreview) return;

        reasonPreview.textContent = reason.value.trim() || emptyReason;
    };

    const showStep = function (step) {
        updateSummary();

        form.querySelectorAll('[data-step-panel]').forEach(function (panel) {
            panel.hidden = panel.dataset.stepPanel !== String(step);
        });

        form.querySelectorAll('[data-step-indicator]').forEach(
            function (indicator) {
                const indicatorStep = Number(indicator.dataset.stepIndicator);
                indicator.classList.toggle('is-active', indicatorStep === step);
                indicator.classList.toggle('is-complete', indicatorStep < step);
            }
        );
    };

    form.querySelectorAll('[data-next-step]').forEach(function (button) {
        button.addEventListener('click', function () {
            showStep(2);
        });
    });

    if (reason) {
        reason.addEventListener('input', updateSummary);
    }

    form.querySelectorAll('[data-prev-step]').forEach(function (button) {
        button.addEventListener('click', function () {
            showStep(1);
        });
    });

    showStep(form.dataset.submitted === '1' ? 3 : 1);
});
